import React, {Suspense} from 'react';
import AppLoader from '@crema/components/AppLoader';
const Signin = React.lazy(() => import('../../../modules/auth/Signin'));

const ForgotPassword = React.lazy(
  () => import('../../../modules/auth/ForgetPassword'),
);
const ConfirmSignupAwsCognito = React.lazy(
  () => import('../../../modules/auth/Signup/ConfirmSignupAwsCognito'),
);
const ResetPasswordAwsCognito = React.lazy(
  () => import('../../../modules/auth/ForgetPassword/ResetPasswordAwsCognito'),
);
export const authRouteConfig = [
  {
    path: '/signin',
    element: (
      <Suspense fallback={<AppLoader />}>
        <Signin />
      </Suspense>
    ),
  },
  {
    path: '/forget-password',
    element: (
      <Suspense fallback={<AppLoader />}>
        <ForgotPassword />
      </Suspense>
    ),
  },
  {
    path: '/confirm-signup',
    element: <ConfirmSignupAwsCognito />,
  },
  {
    path: '/reset-password',
    element: (
      <Suspense fallback={<AppLoader />}>
        <ResetPasswordAwsCognito />
      </Suspense>
    ),
  },
];
